<div>
    <div class="claim-filter-section" [appIsLoading]="loadingService.isLoading(this)">
        <cs-shared-message-page filterByKey="categoryIds" [categoryDetails]="categoryDetails"
            [articleDetails]="articleDetails">
        </cs-shared-message-page>
    </div>
</div>